export default __webpack_public_path__ + "static/media/Google-Play.4da9c087.svg";